<template>
	<v-carousel height="auto" hide-delimiters show-arrows-on-hover :cycle="cycle" class="main-slide" v-model="model">
		<v-carousel-item :ripple="false" v-for="(banner, index) in banners" :key="index">
			<v-img v-if="banner.open" :src="banner.image" width="100%" contain :aspect-ratio="640 / 820" @click.stop="$emit('open', banner.open)"/>
			<router-link v-if="banner.to" :to="banner.to"><v-img :src="banner.image" width="100%" contain :aspect-ratio="640 / 820" /></router-link>
			<v-img v-if="!banner.to && !banner.open" :src="banner.image" width="100%" contain :aspect-ratio="640 / 820" />
		</v-carousel-item>
	</v-carousel>
</template>

<script>
export default {
	props: {
		banners: { type: Array }
	},
	data() {
		return {
			cycle: true,
			model: 0
		}
	}
}
</script>

<style>

</style>